<template>

  <div>
    <template v-if="context.parent && context.parent.tag==='subForm'">
      <el-switch v-if="type==='fill'" v-model="data[element.id]" inline-prompt active-text="是" inactive-text="否"
                 :disabled="context.authentication.isDisabled(element,data)"/>
      <div v-else-if="type==='detail'">
        <el-switch inline-prompt :model-value="data[element.id]" active-text="是" inactive-text="否"/>
      </div>
    </template>

    <el-form-item v-else :required="context.authentication.isRequired(element)">
      <template #label>
       <span :style="{color:'#344262','font-weight':context.form.setting.style.PC.title}">
        {{ element.label }}
        <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
      </template>
      <el-switch v-if="type==='fill'" v-model="data[element.id]" inline-prompt active-text="是" inactive-text="否"
                 :disabled="context.authentication.isDisabled(element,data)"/>
      <div v-else-if="type==='detail'" class="design-detail">
        <el-switch inline-prompt :model-value="data[element.id]" active-text="是" inactive-text="否"/>
      </div>
    </el-form-item>
  </div>
</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import {useFormStore} from "@/stores/form";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";
import {dynamicFunction} from "@/pojo/script";
import {debounce} from "lodash";

export default {
  components: {FormElementTooltip},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      data: {},
      type: '',
      debouncedHandler: debounce((newValue, oldValue) => {
        try {
          this.data[this.element.id] = dynamicFunction(this.element.default.script.value, {...this.data,...(this.context.rawData || {})});        } catch (e) {
          console.error(this.element.default.script.value, e)
        }
      }, 100),
    }
  },
  computed: {
    ...mapStores(useFlowStore,useFormStore)
  },
  created() {
    this.data = this.context.data;
    if (typeof this.data[this.element.id] === 'string') {
      this.data[this.element.id] = false;
    }
    this.type = this.flowStore.typeOfElement(this.element, this.context);
  },
  mounted() {
    this.initWatch();
  },
  unmounted() {
    if ( this.element.default?.script?.value)
      this.debouncedHandler();
  },
  methods:{
    initWatch() {

      if (this.type === 'fill' && this.element.default.select === 'script' && this.element.default.script.value.length > 0) {

        if (!this.data[this.element.id] || this.element.default.isAlwaysScript) {
          this.debouncedHandler()
        }

        let columns = this.formStore.columnsFlatMap(this.context.form);
        if (this.context.rawData) {

          Object.keys(this.context.rawData)
              .filter(filter=>filter!==this.element.id)
              .filter(filter => columns.some(some => !some.parent && some.id === filter))
              .filter(filter => this.element.default.script.value.includes(filter)).forEach(key => {

            this.$watch(`context.rawData.${key}`, this.debouncedHandler, {
              deep: true,
              immediate: false
            });
          });
        }

        Object.keys(this.data)
            .filter(filter=>filter!==this.element.id)
            .filter(filter => columns.some(column =>  column.id === filter))
            .filter(filter => this.element.default.script.value.includes(filter)).forEach(key => {

          this.$watch(`data.${key}`, this.debouncedHandler, {
            deep: true,
            immediate: false
          });

        });
      }

    },
  }
}

</script>

<style scoped lang="scss">

</style>